import { useCurrentUserFieldThrows } from '../users';

type UseCanCurrentUserAccessEnhancedUserProfile = () => boolean;
export const useCanCurrentUserAccessEnhancedUserProfile: UseCanCurrentUserAccessEnhancedUserProfile = () => {
  const isCurrentUserGuest = useCurrentUserFieldThrows('isGuest');

  return !isCurrentUserGuest;
};
